var _rect, _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIComplexo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 64,
    height: 64,
    rx: 32,
    fill: "#1D5187"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_226_647)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20.5094 43.4906C19.0719 42.0531 20.025 39.0328 19.2938 37.2641C18.5344 35.4375 15.75 33.9531 15.75 32C15.75 30.0469 18.5344 28.5625 19.2938 26.7359C20.025 24.9687 19.0719 21.9469 20.5094 20.5094C21.9469 19.0719 24.9687 20.025 26.7359 19.2938C28.5703 18.5344 30.0469 15.75 32 15.75C33.9531 15.75 35.4375 18.5344 37.2641 19.2938C39.0328 20.025 42.0531 19.0719 43.4906 20.5094C44.9281 21.9469 43.975 24.9672 44.7063 26.7359C45.4656 28.5703 48.25 30.0469 48.25 32C48.25 33.9531 45.4656 35.4375 44.7063 37.2641C43.975 39.0328 44.9281 42.0531 43.4906 43.4906C42.0531 44.9281 39.0328 43.975 37.2641 44.7063C35.4375 45.4656 33.9531 48.25 32 48.25C30.0469 48.25 28.5625 45.4656 26.7359 44.7063C24.9687 43.975 21.9469 44.9281 20.5094 43.4906Z",
    stroke: "#B5E9FF",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32 24.5V33.25",
    stroke: "#B5E9FF",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32 40.75C33.0355 40.75 33.875 39.9105 33.875 38.875C33.875 37.8395 33.0355 37 32 37C30.9645 37 30.125 37.8395 30.125 38.875C30.125 39.9105 30.9645 40.75 32 40.75Z",
    fill: "#B5E9FF"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_226_647"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    fill: "white",
    transform: "translate(12 12)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIComplexo);
export default __webpack_public_path__ + "static/media/i-complexo.04246bc6fbe3e75db0e1c6335fb576c6.svg";
export { ForwardRef as ReactComponent };